export enum Mode {
  DRAW = 'DRAW',
  DEFORMATION = 'DEFORMATION',
}
